import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router"
import { QueryClient, QueryClientProvider } from "react-query";
import Loader from "./components/UI/Loader";
import ErrorProvider from "./components/errors/ErrorProvider";
import 'material-icons/iconfont/material-icons.css';
import './App.scss';

const MainView = lazy(() => import('./components/MainView'));
const NotFound404 = lazy(() => import('./components/errors/NotFound404'));
const queryClient = new QueryClient();

const App = () => {

    return (
        <QueryClientProvider client={queryClient}>
            <ErrorProvider>
                <Suspense fallback={<Loader />}>
                    <Switch>
                        <Route exact path='/' component={MainView} />
                        <Route exact path='/:hospitalId/' component={MainView} />
                        <Route path='*' component={NotFound404} />
                    </Switch>
                </Suspense>
            </ErrorProvider>
        </QueryClientProvider >
    );
};

export default App;
